var _rect, _path, _path2, _path3, _ellipse, _ellipse2, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMortgagePlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 81,
    viewBox: "0 0 78 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.15448,
    y: 55.1315,
    width: 11.4485,
    height: 19.9948,
    rx: 0.167531,
    stroke: "white",
    strokeWidth: 3.01555
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8473 56.4215H21.3453C24.2477 56.4215 32.8597 59.5522 35.2931 60.8559C38.2762 60.8559 44.1617 60.8559 48.4348 60.8559C51.9822 60.8559 52.2241 67.7895 48.4348 67.7895H47.2254H30.8589M13.8473 72.3045L25.4571 77.3032C31.1813 79.4801 38.2762 79.6495 44.2424 77.3032C51.4178 74.4814 60.6895 71.1959 65.2045 69.0795C69.0744 67.2655 67.3007 60.8559 62.6245 62.549L49.5635 67.7895",
    stroke: "white",
    strokeWidth: 3.01555
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7908 9.09495L12.557 29.1704C9.33205 31.186 6.34897 26.6589 9.33204 24.5748C14.0405 21.2854 33.8416 8.20808 42.7908 2",
    stroke: "white",
    strokeWidth: 3.01555
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1573 9.09495L71.3911 29.1704C74.6161 31.186 77.5991 26.6589 74.6161 24.5748C69.9077 21.2854 50.1065 8.20808 41.1573 2",
    stroke: "white",
    strokeWidth: 3.01555
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.5976,
    cy: 30.7827,
    rx: 4.19242,
    ry: 4.19247,
    stroke: "white",
    strokeWidth: 2.68049
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.6894,
    cy: 47.8755,
    rx: 4.19242,
    ry: 4.19247,
    stroke: "white",
    strokeWidth: 2.68049
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3483 28.0415L30.7737 50.697",
    stroke: "white",
    strokeWidth: 3.01555
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9619 62.1455V25.1389M19.329 56.8243V25.1389",
    stroke: "white",
    strokeWidth: 3.01555
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9593 17.7217V7.00493C64.9593 6.91241 64.8843 6.8374 64.7918 6.8374H57.9513C57.8588 6.8374 57.7838 6.91241 57.7838 7.00493V13.0455",
    stroke: "white",
    strokeWidth: 3.01555
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgagePlanning);
export default __webpack_public_path__ + "static/media/Mortgage-Planning.d40c408c9314e2d6714cd0252e5b03ce.svg";
export { ForwardRef as ReactComponent };